import * as React from 'react';
import { Col as ColStrap } from 'reactstrap';
import * as common from '../common';

export type ColumnProps
    = string
    | boolean
    | number
    | {
        size?: boolean | number | string
        push?: string | number
        pull?: string | number
        offset?: string | number
    };

export interface IColProps extends common.ILayoutPropsBase {
    tag?: React.ReactType;
    xs?: ColumnProps;
    sm?: ColumnProps;
    md?: ColumnProps;
    lg?: ColumnProps;
    xl?: ColumnProps;
    xxl?: ColumnProps;
    xxxl?: ColumnProps;

    widths?: string[];
}

export const maxColsCount = 24;

export const Col = (props: IColProps) => {
    return <ColStrap {...props} />;
};